import { NgModule } from "@angular/core";
import { Routes, RouterModule,Router } from "@angular/router";
import { NgxsModule } from "@ngxs/store";
import { DialogModule, DialogConfig } from '@tmhcc-ng-lib/framwork/dialog';
import { ReactiveFormsModule,FormsModule,FormGroupDirective } from '@angular/forms';
import { OktaAuthGuard } from '@okta/okta-angular';
import { CommonModule } from "@angular/common";

import { WUWDashboardComponent } from './wuw-dashboard.component';
import { KnrPolicyQuoteService } from "libs/data-service/kidnap-ransom/knr-policy-quote.service";

import { CoreInputsModule } from "@tmhcc-ng-lib/framwork/core-inputs";
export function onAuthRequired(oktaAuth, injector) {
  const router = injector.get(Router);
  router.navigate(['/login']);
}
const routes: Routes = [
  {
    path: "",
    component: WUWDashboardComponent      
  }
];

@NgModule({
  declarations: [WUWDashboardComponent],   
  imports: [
    RouterModule.forChild(routes),    
    ReactiveFormsModule,
    FormsModule,
    DialogModule,
    CommonModule,       
    CoreInputsModule,   
  ],
  providers: [    
    DialogConfig,
    OktaAuthGuard,
    FormGroupDirective,
    KnrPolicyQuoteService    
  ],  
  //entryComponents: [KnrSearchComponent,KnrViewSearchComponent, KnrAccountSetupComponent],
  exports: [RouterModule,WUWDashboardComponent]
})
export class WUWDashboardModule { }
